import { createFileRoute } from "@tanstack/react-router";
import { previewRouteOptions } from "@/features/preview/navigation";

export const Route = createFileRoute("/_site/$coworld/$league/preview")({
  ...previewRouteOptions,
});
